import { Box, Button, makeStyles } from "@material-ui/core";
import {
  EventLogActionType,
  EventLogInputType,
  EventLogTextType
} from "../../../utils/event-log-input-type";
import { useLocale } from "@hooks";
import { EventType } from "../../../utils/hook-props";

type Props = {
  consultantId: string;
  inputType: EventLogInputType | null;
  textAreaContent: string;
  setTextAreaContent: (content: string) => void;
  isLoading: boolean;
  setLoading: (loading: boolean) => void;
  onSubmit: () => void;
  onSuccess: (event?: EventType) => void;
  inputDisabled?: boolean;
};

export const InputButtons = (props: Props) => {
  const classes = useStyles();
  const { locale } = useLocale();

  if (!props.inputType) {
    return (
      <div className={classes.root} style={{ visibility: "hidden" }}>
        <Button />
      </div>
    );
  }

  switch (props.inputType) {
    case EventLogTextType.Call:
      return (
        <Box className={classes.root}>
          <Button
            variant="contained"
            color="primary"
            disabled={!props.textAreaContent || props.isLoading}
            onClick={() => props.onSubmit()}
          >
            {locale.Save}
          </Button>
        </Box>
      );
    case EventLogTextType.Comment:
      return (
        <Box className={classes.root}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.onSubmit()}
            disabled={props.isLoading}
          >
            {locale.Save}
          </Button>
        </Box>
      );
    case EventLogActionType.Email:
    case EventLogActionType.Noanswer:
    case EventLogActionType.Interest:
      return undefined;
    default:
      return undefined;
  }
};

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "row",
    columnGap: "0.5rem",
    justifyContent: "flex-end",
    marginTop: "0.5rem"
  }
}));
